import React, { useEffect, useState } from "react";
import { useUser } from "util/UserContext";
import TeamsList from "./TeamsList";
import ScrollHideContainer from "ui/ScrollHideContainer";
import ScrollableTabsList from "ui/ScrollableTabsList";
import { setDocumentTitle, setDefaultSiteOg } from "util/ogMetadataUtils";
import { capitalizeFirstLetter } from "util/textUtils";
import { useParams } from "react-router-dom";
/**
 * TeamsTabs component that handles displaying tabs for Teams/Parteas
 * Shows "All Parteas" by default, and "My Parteas" tab for logged-in users
 */
const TeamsTabs: React.FC = () => {
  const { currentUser } = useUser();
  const { tab } = useParams<{ tab?: string }>();
  const [selectedTab, setSelectedTab] = useState<string>("all");

  setDocumentTitle(`Parteas - ${capitalizeFirstLetter(selectedTab)}`);
  useEffect(() => {
    setDefaultSiteOg({ title: document.title, url: window.location.href });
  }, [selectedTab]);

  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    } else {
      setSelectedTab('all');
    }
  }, [tab]);

  // Build tabs data based on user authentication status
  const tabsData = [
    {
      label: "All Parteas",
      value: "all",
      route: `/parteas/all`,
    }
  ];

  // Add "My Parteas" tab only if user is logged in
  if (currentUser) {
    tabsData.push({
      label: "My Parteas",
      value: "member",
      route: `/parteas/member`,
    });
  }

  // Handle tab change
  const handleTabChange = (newTab: string) => {
    setSelectedTab(newTab);
  };


  return (
    <div className="py-0 relative">
      <ScrollHideContainer 
        className="z-50 max-w-5xl bg-eoe-bg dark:bg-eoe-dark-bg"
        hideOffset={57}
        threshold={56}
      >
        <div className="p-2">
          <ScrollableTabsList
            key="teams-tabs"
            pageTitle="Parteas"
            tabs={tabsData}
            selectedTab={selectedTab}
            onTabChange={handleTabChange}
          />
        </div>
      </ScrollHideContainer>

      {/* Tabs Content */}
      <div className="py-2 px-2 md:px-4 relative">
        {selectedTab === "all" && (
          <TeamsList 
            isLoading={() => {}} 
            onlyMemberTeams={false} 
          />
        )}
        {selectedTab === "member" && currentUser && (
          <TeamsList 
            isLoading={() => {}} 
            onlyMemberTeams={true} 
          />
        )}
      </div>
    </div>
  );
};

export default TeamsTabs;
